import React, { useState } from 'react';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import { connect } from 'react-redux';
import './proceed.css';
import { AUTO_PLAY_BEHAVIOUR, EVENT_TYPE } from '../../constants';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';

const Proceed = ({
  force,
  userDisplayName,
  onProceed,
  startTime,
  skipForm,
  forcedUiVisible,
  eventType,
  headless,
  autoPlayBehavior,
}) => {
  const [proceedName, setProceedName] = useState(userDisplayName);
  const proceedInputChange = (e) => {
    setProceedName(e.target.value.trimStart());
  };
  const onProceedClick = () => {
    if (proceedName !== '') {
      onProceed(force, userDisplayName !== proceedName ? proceedName : null);
    }
  };
  const onKeyUp = (e) => {
    const keyCode = e.keyCode;
    if (keyCode === 13) {
      onProceedClick();
    }
  };

  if (
    (!headless && eventType === EVENT_TYPE.HLS_RECORDING) ||
    (headless && (autoPlayBehavior === AUTO_PLAY_BEHAVIOUR.NEVER || forcedUiVisible))
  ) {
    return (
      <div className="proceedPlayBtn">
        <div className="play">
          <PlayArrowRoundedIcon onClick={() => onProceedClick()} />
        </div>
      </div>
    );
  }

  if (headless) {
    return <div className="headlesswaitMsg">Please wait, live stream will begin shortly</div>;
  }

  if (!force && skipForm) {
    return (
      <div className="proceedPlyBtn" onClick={onProceedClick}>
        <div className="playButton">
          <LiveTvIcon />
          <span>The event is LIVE</span>
          <div className="joinBtn">Join Now!</div>
        </div>
      </div>
    );
  }

  return (
    <div className="proceedPlyBtn join-now">
      <div className="playButton">
        <LiveTvIcon />
        <span className={`${!skipForm && !force ? 'liveMessage' : ''}`}>The event is LIVE</span>

        <div className={`form-row ${!skipForm && !force ? 'inputForm' : ''}`}>
          {!skipForm && (
            <input
              aria-invalid="false"
              name="proceedName"
              id="proceedName"
              placeholder="Enter your name"
              type="text"
              className={proceedName ? '' : 'error'}
              value={proceedName}
              onChange={proceedInputChange}
              onKeyUp={onKeyUp}
              autoFocus={true}
              enterKeyHint="go"
            />
          )}
          <button
            className={`joinBtn ${forcedUiVisible ? 'disabled' : ''}`}
            tabIndex="0"
            type="button"
            disabled={proceedName === '' || forcedUiVisible}
            onClick={onProceedClick}
          >
            {force && skipForm ? 'Join Now!' : 'Join Now!'}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    title: state.app.title,
    desc: state.app.desc,
    startTime: state.app.welcomeData.meta.starttime,
    // startTime: Date.now() + 10 * 1000,
    eventStatus: state.app.eventStatus,
    sessionState: state.app.sessionState,
    userDisplayName: state.app.userDisplayName,
    proceedClickCaptured: state.app.proceedClickCaptured,
    sessionExpired: state.app.sessionExpired,
    skipForm: state.app.apiJsonConfig.skipForm,
    mode: state.app.mode,
    goLive: state.app.goLive,
    liveDuration: state.app.liveDuration,
    eventType: state.app.eventType,
    headless: state.app.config.headless,
    autoPlayBehavior: state.app.autoPlayBehavior,
  };
};

// export default Proceed;

export default connect(mapStateToProps)(Proceed);
